import React from 'react'

function ResetTitle() {
  return (
    <h1 className="reset-title">Redefinir Senha</h1>
  )
}

export default ResetTitle;